import type { LucideIcon } from 'lucide-react'
import { Inbox } from 'lucide-react'
import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon?: LucideIcon | undefined
  title: string
  description?: string | undefined
  action?: ReactNode | undefined
}

export function EmptyState({ icon: Icon = Inbox, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-card border border-dashed border-shell-border bg-shell py-14 px-6 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-shell border border-shell-border text-shell-text shadow-card">
        <Icon size={20} />
      </div>
      <h3 className="mt-4 font-display text-sm font-semibold text-shell-text-active">{title}</h3>
      {description && <p className="mt-1.5 max-w-xs text-sm text-shell-text">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
